// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1VJh4","consentsList":"PatientConsents_consentsList__1g17a","consentsListEmpty":"PatientConsents_consentsListEmpty__1_GUb"};